import { TENTATIVE_INCOME_NAME } from "web_myplann/Finances/constants";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const createTentativeIncome = (
	id: number | null,
	amount: number,
	t: TranslateFunction,
): FinanceState["income"][number] => ({
	id,
	name: t(TENTATIVE_INCOME_NAME),
	amount,
});
